export default __webpack_public_path__ + "static/media/pdf.fe2fc010.svg";